// Проверяем наличие ключей в объекте
function isEmptyObject(emptyObject) {
  return emptyObject && Object.keys(emptyObject).length === 0 && Object.getPrototypeOf(emptyObject) === Object.prototype
}

export default isEmptyObject
